import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bottom-slot-action-bar" }

import { inject } from "vue";
import { isModalVisibleInjectionKey } from "../modal-dialog/ds-modal-dialog-injection-key";
import DsButton from "../button/ds-button.vue";
import type { SvgIcons } from "../icon/types";
import { Theme } from "../types/theme";
import { Size } from "../types/size";
import { ButtonType } from "../types/button";

type IconType = {
    iconLeft?: SvgIcons;
    iconRight?: SvgIcons;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-bottom-slot-action-bar',
  props: {
    hasBtnSubmit: { type: Boolean, default: true },
    btnSubmitText: { default: "POTVRDIT" },
    btnSubmitDataTest: {},
    btnCloseText: { default: "ZAVŘÍT" },
    btnCloseDataTest: {},
    hasBtnClose: { type: Boolean, default: true },
    isColumn: { type: Boolean, default: false },
    buttonsDisabled: { type: Boolean, default: false },
    buttonCloseIcon: {},
    buttonSubmitIcon: {},
    isInStorybook: { type: Boolean },
    theme: {},
    size: {},
    btnSubmitType: { default: "primary" },
    btnCloseType: { default: "secondary" }
  },
  emits: ["submitDialog", "closeDialog"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isModalVisible = inject(isModalVisibleInjectionKey);

const emit = __emit;

const submitDialog = () => {
    emit("submitDialog", null);
};

const modalClose = () => {
    emit("closeDialog", null);
    isModalVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bottom-slot-action-bar__wrap", { 'bottom-slot-action-bar__wrap--column': _ctx.isColumn }])
    }, [
      _renderSlot(_ctx.$slots, "additional"),
      (props.hasBtnClose)
        ? (_openBlock(), _createBlock(DsButton, {
            key: 0,
            "icon-left": props.buttonCloseIcon ? props.buttonCloseIcon.iconLeft : undefined,
            "icon-right": props.buttonCloseIcon ? props.buttonCloseIcon.iconRight : undefined,
            "is-in-story-book": props.isInStorybook,
            "is-disabled": props.buttonsDisabled,
            type: _ctx.btnCloseType,
            onClick: modalClose,
            "data-test": _ctx.btnCloseDataTest,
            theme: _ctx.theme,
            size: _ctx.size
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.btnCloseText), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "icon-right", "is-in-story-book", "is-disabled", "type", "data-test", "theme", "size"]))
        : _createCommentVNode("", true),
      (props.hasBtnSubmit)
        ? (_openBlock(), _createBlock(DsButton, {
            key: 1,
            "is-disabled": props.buttonsDisabled,
            type: _ctx.btnSubmitType,
            onClick: submitDialog,
            "icon-left": props.buttonSubmitIcon ? props.buttonSubmitIcon.iconLeft : undefined,
            "icon-right": props.buttonSubmitIcon ? props.buttonSubmitIcon.iconRight : undefined,
            "is-in-story-book": props.isInStorybook,
            "data-test": _ctx.btnSubmitDataTest,
            theme: _ctx.theme,
            size: _ctx.size
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.btnSubmitText), 1)
            ]),
            _: 1
          }, 8, ["is-disabled", "type", "icon-left", "icon-right", "is-in-story-book", "data-test", "theme", "size"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})